import { ca } from '@cian/analytics';
import { TDevice } from '@cian/utils';

import { getBannerSource } from '../../utils/getBannerSource';

export const trackStartQuizEvent = (deviceType: TDevice) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click',
    label: 'Start',
    page: {
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
      pageType: 'application_form',
      extra: {
        banner_location: getBannerSource(),
      },
    },
  });
};
